import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { PrerequisitesStatusHeader } from "Components/Hunter/HunterPrerequisitesForm/PrerequisitesStatusHeader";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import {
  type HunterPrerequisiteItemDto,
  PrerequisiteCompletionStatus,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.HunterPrerequisites;

type Props = {
  prerequisites: Array<HunterPrerequisiteItemDto>;
  completedCount: number;
  totalCount: number;
};

export const HunterPrerequisitesReadOnly = ({
  prerequisites,
  completedCount,
  totalCount,
}: Props) => {
  const { t } = useResource();

  return (
    <PrimaryPaper>
      <Stack gap={2}>
        <PrerequisitesStatusHeader
          completedCount={completedCount}
          totalCount={totalCount}
        />

        {prerequisites.map(({ prerequisiteType, completionStatus, note }) => {
          const isCompleted =
            completionStatus !== PrerequisiteCompletionStatus.NotCompleted;
          const isAutomatic =
            completionStatus === PrerequisiteCompletionStatus.Automatic;

          return (
            <Box
              key={prerequisiteType}
              display="flex"
              alignItems="flex-start"
              gap={1}
            >
              {isAutomatic ? (
                <VerifiedOutlinedIcon
                  color="success"
                  fontSize="small"
                  sx={{ mt: 0.25 }}
                />
              ) : isCompleted ? (
                <CheckCircleOutlineIcon
                  color="success"
                  fontSize="small"
                  sx={{ mt: 0.25 }}
                />
              ) : (
                <RadioButtonUncheckedIcon
                  color="disabled"
                  fontSize="small"
                  sx={{ mt: 0.25 }}
                />
              )}
              <Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="body2">
                    {t(RESOURCES.Items[prerequisiteType])}
                  </Typography>
                  {isAutomatic && (
                    <Chip
                      label={t(RESOURCES.AutoVerified)}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  )}
                </Box>
                {note && (
                  <Typography variant="caption" color="text.secondary">
                    {note}
                  </Typography>
                )}
              </Box>
            </Box>
          );
        })}
      </Stack>
    </PrimaryPaper>
  );
};
